export default [
    {
        path: '',
        name: 'AccountIndex',
        component: () => import('../views/pages/account/client/settings/Index.vue'),
        meta: {
            title: 'Moje konto'
        }
    },
    {
        path: 'reservations',
        name: 'ClientReservations',
        component: () => import('@/views/pages/account/client/reservations/Index.vue'),
        meta: {
            title: 'Rezerwacje'
        }
    },
    {
        path: 'settings',
        name: 'ClientSettings',
        component: () => import('@/views/pages/account/client/settings/Index.vue'),
        meta: {
            title: 'Ustawienia'
        }
    }
]
